import React, { Component } from 'react';
import AppBar from 'material-ui/AppBar';

class GuestHeader extends Component {

    constructor() {
        super(...arguments);

        this.state = {
            pageTitle: 'C-TMS',
        };
    }

    render() {
        return (
            <div>
                <AppBar
                    title={this.state.pageTitle}
                    onLeftIconButtonTouchTap={this.props.toggleLeftNav}
                    style={{ position: 'fixed' }}
                />
            </div>
        );
    }

}

export default GuestHeader;
